import { Link } from 'react-router-dom';

// Components
import Heading from '@/components/atoms/Heading/Heading';

// Utils
import cn from '@/utils/cn';

// Other
import { type BlocMarquesType } from '@/services/blocksSchema';
import Vector from '@/assets/blocks/vector-shadow-grey-small.svg?react';

// Style
import styles from './BlocMarques.module.css';

interface BlocMarquesProps {
  title: BlocMarquesType['title'];
  carouselSpeed: BlocMarquesType['carouselSpeed'];
  brands?: BlocMarquesType['brands'];
}

function BlocMarques({
  title,
  carouselSpeed,
  brands = null,
}: BlocMarquesProps) {
  
  const getSpeed = (speed: string) => {
    switch (speed) {
    case 'lente':
      return 'slow';
    case 'moyenne':
      return 'medium';
    case 'rapide':
      return 'fast';
    default:
      return 'medium';
    };
  };

  return (
    <div>
      <div className={styles.container}>
        <Heading
          title={title}
          size='h4'
          Tag='h4'
          color='dark'
        />
      </div>
      <div className={styles.logos}>
        <div
          className={cn([
            styles.slide,
            styles[`slide-${getSpeed(carouselSpeed)}`]
          ])}
        >          
          {
            brands ? (
              brands.map((brand) => (
                <Link key={brand.url} to={brand.url}>
                  <img
                    key={`slide1-${brand.url}`}
                    src={brand.image.url}
                    alt={brand.image.alternativeText || ''}
                    className={styles['slide-image']}
                  />
                </Link>
              ))
            ) : null
          }
        </div>
        <div
          className={cn([
            styles.slide,
            styles[`slide-${getSpeed(carouselSpeed)}`]
          ])}
        >          
          {
            brands ? (
              brands.map((brand) => (
                <Link key={brand.url} to={brand.url}>
                  <img
                    key={`slide2-${brand.url}`}
                    src={brand.image.url}
                    alt={brand.image.alternativeText || ''}
                    className={styles['slide-image']}
                  />
                </Link>
              ))
            ) : null
          }
        </div>
      </div>
      <Vector />
    </div>
  );
}

export default BlocMarques;
